import { MutationTree } from "vuex";
import { UserState } from "./types";

interface UserPayload {
  id: number;
  login: string;
  token: string;
  avatar: string;
}

export const mutations: MutationTree<UserState> = {
  userLoaded(state, payload: UserPayload) {
    state.id = payload.id;
    state.login = payload.login;
    state.token = payload.token;
    state.avatar = payload.avatar;
  },
  userReset(state) {
    state.id = -1;
    state.login = "";
    state.token = "";
    state.avatar = "";
  },
  setUnreadMessagesCount(state, count: number) {
    state.unreadMessagesCount = count;
  },
  setUnreadNotificationsCount(state, count: number) {
    state.unreadNotificationsCount = count;
  },
};
